import { CACHE_TIERS } from "@workspace/types";
import { trpc } from "@/lib/trpc/react";

/**
 * tRPC-enabled hook for fetching individual show details
 * Maintains the same API as the original hook for easy migration
 */
export function useShowDetails(
	slug: string,
): ReturnType<typeof trpc.show.getBySlug.useQuery> {
	return trpc.show.getBySlug.useQuery(
		{ slug },
		{
			enabled: !!slug,
			...CACHE_TIERS.STATIC, // Static content - show details rarely change
		},
	);
}
